import { fromJS } from 'immutable';

export default fromJS({
    keyfobs: [],
    memberToDeactivateMembership: undefined,
    keyfobToReassign: undefined,
    isReassignKeyfobFeatureEnabled: false,
    memberToDelete: undefined,
    membersWaitingToInviteCount: 0
});